import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import logo from "../YB1type_Blk.png";
import "./error.css";

function getTitle(status: number | undefined) {
  switch (status) {
    case 401:
      return "fatal_error_cloud_title_401";
    case 403:
      return "fatal_error_cloud_title_403";
    case 404:
      return "fatal_error_cloud_title_404";
    case 502:
      return "fatal_error_cloud_title_502";
  }
  return "";
}

function getMessage(status: number | undefined) {
  switch (status) {
    case 401:
      return "fatal_error_cloud_message_401";
    case 403:
      return "fatal_error_cloud_message_403";
    case 404:
      return "fatal_error_cloud_message_404";
    case 502:
      return "fatal_error_cloud_message_502";
  }
  return "fatal_error_cloud_message";
}

export interface IProps {
  /**
   * httpステータスコード
   */
  status: number | undefined;
  /**
   * ログアウトボタンが押された場合に呼び出されます。
   */
  onLogout?: () => void;
}

export default function FatalErrorCloudPage(props: IProps): JSX.Element {
  const { status, onLogout } = props;
  const { t } = useTranslation();
  console.log(status);
  const title = getTitle(status);
  const message = getMessage(status);
  return (
    <div className="screen">
      <div className="area">
        <img src={logo} className="logo" alt="logo" />
        <div className="title">{t(title)}</div>
        <div className="message">{t(message)}</div>
        <Button className="button" onClick={onLogout}>
          {t("fatal_error_cloud_move_login")}
        </Button>
      </div>
    </div>
  );
}
